import Vue from 'vue';
import Component from 'vue-class-component';
import Fragment from 'vue-fragment';
import '@gig/magic-message-bus';
import '@gig/magic-ab-test';
import { Feature } from '@gig/magic-messages';

// Uncomment for message bus logging
// window.eventBus.enableLogging();
// window.queryBus.enableLogging();
// window.commandBus.enableLogging();

import { magic } from '@gig/magic-sdk';
import {
    links,
    initializeTheme,
    registerTrackingService,
    languageQuery,
    getFeatureEnabled
} from '@gig/magic-common';
import { TrackingServiceV2 } from '@gig/magic-common/dist/services/tracking/tracking-v2.service';

import { App } from './components/app';
import { config, setHtmlLang, eyeAbleService } from './services';
import { getRouter } from './routes/router';
import { store } from './store';
import {
    COUNTRY_TO_JURISDICTION,
    i18nQuery,
    toolkit,
} from '@gig/magic-frontend-toolkit';
import { Jurisdiction } from '@gig/magic-jurisdictions';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['shady-slot', 'slot', /^magic-/];

// Register the router hooks with their names
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

// If we're running inside Cypress
if ((window as any).Cypress) {
    // Export magic to use in our tests.
    (window as any).magic = magic;
    (window as any).inTestEnvironment = true;

    // Set configuration overrides on page load and expose config for on the fly configuration modification.
    const cyConfiguration = (window as any)._configTransformer;
    if (cyConfiguration) {
        cyConfiguration(config);
    }

    const skipGeolocation = (window as any).Cypress.config('skip-geolocation');
    if (skipGeolocation) {
        delete config.geoLocation;
    }

}

const defaultJurisdiction = Jurisdiction.AGLC;

// Set the initial theme to light or dark;
initializeTheme();

// Register tracking service version for use in this project
const trackingService = new TrackingServiceV2();
registerTrackingService(trackingService);

// Removes the splash screens
function removeSplashScreen() {
    document.body.classList.add('is-loaded');
}

// if the PendingQueryTimeoutInMs default value needs to be overridden
/* if (window.inTestEnvironment) {
    // Overrides the PendingQueryTimeoutInMs default value
    // with the new value, provided in milliseconds
    window.queryBus.overridePendingQueryTimeoutInMs(11000);
} */

async function initializeEyeAble(): Promise<void> {
    try {
        const isEyeAbleEnabled = await getFeatureEnabled(Feature.EYE_ABLE_ENABLED);

        if (isEyeAbleEnabled && config.eyeAble?.apiKey?.trim()) {
            await eyeAbleService.load();
        }
    } catch (error) {
        console.error('[App] Eye-Able initialization failed:', error);
    }
}

toolkit
    .bootstrap(config, COUNTRY_TO_JURISDICTION, defaultJurisdiction)
    .then(async () => {
        Vue.use(Fragment.Plugin);

        const [lang, i18n, router] = await Promise.all([
            languageQuery(),
            i18nQuery(),
            getRouter(),
        ]);

        setHtmlLang(lang);
        removeSplashScreen();
        new Vue({
            i18n,
            router,
            store,
            render: (h) => h(App),
        }).$mount('#app');

        links.registerLinkHandler((path) => {
            router.push(path).catch(() => null);
        });

        await initializeEyeAble();
    });
